module.exports = __webpack_public_path__ + "assets/img/9.86b8e95f.jpg";